import {LoginActions} from "@ignitesales/neuro-application";
import {defaultSchema as formDefaultSchema, commonFields} from "@ignitesales/neuro-application/src/neuro-guide/guide-framework/state/Login/LoginConstants.mjs";

const loginReducer = (state, action) => {
  const employeeLoginState = state.employeeLoginState || {};
  const disableNewProfiles = state?.guideConfigurations?.runMode === 'production' || state?.guideConfigurations?.runMode === 'pilot' || state?.guideConfigurations?.runMode === 'staging';
  const filterEmployeeId = ( fieldName ) => {
    if (disableNewProfiles) {
      return fieldName !== 'employeeId';
    }
    return true;
  }

  let fields = [
    ...(formDefaultSchema.fields).filter(f => filterEmployeeId(f.name)),
    commonFields.nmlsId,
  ];
  fields = fields.map(f => {
    return {
      ...f,
      disabled: disableNewProfiles
    }
  });
  const requiredFields = formDefaultSchema.required.filter(r => r !== 'phone');
  const loginFormSchema = {
    fields,
    required: requiredFields
  };

  switch (action.type) {
    case LoginActions.LOGIN_FLOW_ENABLED: {
      employeeLoginState.formSchema = loginFormSchema;
      employeeLoginState.disableNewProfiles = disableNewProfiles;
      return {
        ...state,
        employeeLoginState
      }
    }

    default:
      return state;
  }
};

export default loginReducer;
